'use strict';

var React = require('react');

var SvgGiftCardMajor = function SvgGiftCardMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.1 7.45a1.75 1.75 0 1 1 1.74 2.767c.17.136.335.277.489.42.32.294.653.65.842 1.028a.75.75 0 1 1-1.342.67c-.062-.123-.227-.329-.517-.596a10.704 10.704 0 0 0-.94-.757 19.415 19.415 0 0 0-.872-.596c-.233.15-.546.359-.871.596-.332.24-.665.503-.94.757-.29.268-.457.473-.518.596a.75.75 0 1 1-1.342-.67c.189-.377.523-.734.842-1.029.155-.142.32-.283.488-.42a1.75 1.75 0 1 1 1.741-2.766l.6.8.6-.8Zm.9 1.3h.5a.25.25 0 1 0-.2-.4l-.3.4Zm-3.5 0h.5l-.3-.4a.25.25 0 1 0-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 4.5a2.75 2.75 0 0 0-2.75 2.75v5.5a2.75 2.75 0 0 0 2.75 2.75h9.5a2.75 2.75 0 0 0 2.75-2.75v-5.5a2.75 2.75 0 0 0-2.75-2.75h-9.5Zm-1.25 2.75c0-.69.56-1.25 1.25-1.25h3.5v.25a.75.75 0 0 0 1.5 0v-.25h4.5c.69 0 1.25.56 1.25 1.25v2h-1.75a.75.75 0 0 0 0 1.5h1.75v2c0 .69-.56 1.25-1.25 1.25h-4.5v-1.5a.75.75 0 0 0-1.5 0v1.5h-3.5c-.69 0-1.25-.56-1.25-1.25v-2h.75a.75.75 0 0 0 0-1.5h-.75v-2Z"
  }));
};
SvgGiftCardMajor.displayName = "GiftCardMajor";

exports.SvgGiftCardMajor = SvgGiftCardMajor;
